module.exports = __webpack_public_path__ + "img/zhuti-01.1cce43ae.png";